import React, { useState } from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const ApplyEmailModal = ({ isOpen, onClose, job }) => {
  const { styles, isPublic } = useTheme();
  const [copied, setCopied] = useState(false);

  if (!isOpen) return null;

  const handleCopyEmail = () => {
    navigator.clipboard.writeText(job.applyEmail);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleOutsideClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div 
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
      onClick={handleOutsideClick}
    >
      <div className={`${styles.cardBg} rounded-2xl max-w-md w-full border ${styles.cardBorder} shadow-xl`}>
        {/* Header */}
        <div className="flex justify-between items-center p-6 border-b ${styles.border}">
          <h3 className={`text-xl font-bold ${styles.text}`}>
            Apply via Email
          </h3>
          <button 
            onClick={onClose}
            className={`${styles.textMuted} hover:${styles.text} transition-colors`}
          >
            <i className="fas fa-times text-2xl"></i>
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          {/* Job Info (optional - makes modal more contextual) */}
          {job.title && job.company && (
            <div className="mb-4">
              <p className={`${styles.textSecondary} text-sm`}>
                Applying for:
              </p>
              <p className={`${styles.text} font-medium`}>
                {job.title} at {job.company}
              </p>
            </div>
          )}

          {/* Generic Message */}
          <p className={`${styles.textSecondary} mb-6 text-sm`}>
            Please send your application to the following email address. 
            You can copy the email and use your preferred email client.
          </p>

          {/* Email Display */}
          <div className={`${isPublic ? 'bg-gray-800' : 'bg-gray-100'} rounded-xl p-4 mb-6`}>
            <div className="flex items-center justify-between">
              <span className={`font-bold ${styles.text} text-lg break-all pr-4`}>
                {job.applyEmail}
              </span>
              <button
                onClick={handleCopyEmail}
                className={`flex-shrink-0 ${styles.iconPrimary} hover:${isPublic ? 'text-[#00a8e0]' : 'text-primary-700'} transition-colors`}
                title="Copy email"
              >
                <i className={`${copied ? 'fas fa-check' : 'far fa-copy'} text-xl`}></i>
              </button>
            </div>
            {copied && (
              <p className={`text-sm mt-2 ${isPublic ? 'text-[#06D6A0]' : 'text-green-600'}`}>
                <i className="fas fa-check-circle mr-1"></i>
                Email copied to clipboard!
              </p>
            )}
          </div>

          {/* Action Buttons */}
          <div className="flex space-x-3">
            <button
              onClick={() => {
                window.location.href = `mailto:${job.applyEmail}`;
              }}
              className={`flex-1 ${styles.primaryGradient} ${styles.primaryHover} ${styles.primaryText} font-medium px-2 py-1 rounded-xl flex items-center justify-center transition-all duration-300 hover:shadow-lg hover:shadow-[#0096C7]/20`}
            >
              <i className="fas fa-envelope mr-2"></i>
              Open Email Client
            </button>

            <button
              onClick={onClose}
              className={`flex-1 border ${isPublic ? 'border-gray-700 text-gray-400 hover:bg-gray-800' : 'border-gray-300 text-gray-600 hover:bg-gray-50'} px-4 py-3 rounded-xl font-medium transition-colors`}
            >
              Close
            </button>
          </div>

          {/* Note */}
          <p className={`text-xs ${styles.textMuted} text-center mt-4`}>
            We don't track your application. Please apply directly via email.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ApplyEmailModal;